// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-floating1 {
  position: relative;
}
.form-control-inside, /*temp*/
.form-floating1 > .form-control,
.form-floating1 > .form-control-plaintext,
.form-floating1 > .form-select,
.form-floating1 > .form-control-inside {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}

.form-floating1 > .form-control1 > .form-control-inside.form-control-plaintext {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating1 > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

/*
*/

.form-floating1 > .form-control,
.form-floating1 > * > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating1 > .form-control::placeholder,
.form-floating1 > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating1 > .form-control:not(:-moz-placeholder-shown),
.form-floating1 > .form-control-plaintext:not(:-moz-placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
/*.form-floating1 > .form-control:focus,*/
/*.form-floating1 > .form-control:not(:placeholder-shown),*/
/*.form-floating1 > .form-control-plaintext:focus,*/
.form-floating1 > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating1 > .form-control:-webkit-autofill,
.form-floating1 > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating1 > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating1 > .form-control:not(:-moz-placeholder-shown) ~ label,
.form-floating1 > .form-control1 > label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
/*.form-floating1 > .form-control:focus ~ label,*/
/*.form-floating1 > .form-control:not(:placeholder-shown) ~ label,*/
.form-floating1 > label.form-control-mini,
.form-floating1 > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating1 > .form-control-super::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid !important;
  border-right: 0.3em solid transparent;
  border-bottom: 0 !important;
  border-left: 0.3em solid transparent;
}

.form-floating1 > .form-control:not(:-moz-placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
/*.form-floating1 > .form-control:focus ~ label::after,*/
/*.form-floating1 > .form-control:not(:placeholder-shown) ~ label::after,*/
.form-floating1 > .form-control-plaintext ~ label::after,
.form-floating1 > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  /*background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);*/
}
.form-floating1 > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating1 > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating1 > :disabled ~ label,
.form-floating1 > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating1 > :disabled ~ label::after,
.form-floating1 > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.form-floating1 > .form-control1 > .button-container {
  border: 1px dashed #000000;
  border-width: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/FilterButton/filterButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;;;;;EAKE,uDAAuD;EACvD,2DAA2D;EAC3D,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gDAAgD;EAChD,qBAAqB;EACrB,gEAAgE;AAClE;;AAEA;CACC;;AAED;;EAEE,qBAAqB;AACvB;AAKA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA,yCAAyC;AACzC,2DAA2D;AAC3D,mDAAmD;AACnD;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;;EAEE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;;EAEE,2CAA2C;EAC3C,8DAA8D;AAChE;AACA,iDAAiD;AACjD,mEAAmE;AACnE;;EAEE,2CAA2C;EAC3C,8DAA8D;AAChE;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,kCAAkC;EAClC,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,WAAW;EACX,mCAAmC;EACnC,sCAAsC;AACxC;AACA,wDAAwD;AACxD,0EAA0E;AAC1E;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,WAAW;EACX;0CACwC;AAC1C;AACA;EACE,2CAA2C;EAC3C,8DAA8D;AAChE;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB","sourcesContent":[".form-floating1 {\n  position: relative;\n}\n.form-control-inside, /*temp*/\n.form-floating1 > .form-control,\n.form-floating1 > .form-control-plaintext,\n.form-floating1 > .form-select,\n.form-floating1 > .form-control-inside {\n  height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  line-height: 1.25;\n}\n\n.form-floating1 > .form-control1 > .form-control-inside.form-control-plaintext {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n\n.form-floating1 > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: var(--bs-border-width) solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n\n/*\n*/\n\n.form-floating1 > .form-control,\n.form-floating1 > * > .form-control-plaintext {\n  padding: 1rem 0.75rem;\n}\n.form-floating1 > .form-control::-moz-placeholder,\n.form-floating1 > .form-control-plaintext::-moz-placeholder {\n  color: transparent;\n}\n.form-floating1 > .form-control::placeholder,\n.form-floating1 > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating1 > .form-control:not(:-moz-placeholder-shown),\n.form-floating1 > .form-control-plaintext:not(:-moz-placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n/*.form-floating1 > .form-control:focus,*/\n/*.form-floating1 > .form-control:not(:placeholder-shown),*/\n/*.form-floating1 > .form-control-plaintext:focus,*/\n.form-floating1 > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating1 > .form-control:-webkit-autofill,\n.form-floating1 > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating1 > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating1 > .form-control:not(:-moz-placeholder-shown) ~ label,\n.form-floating1 > .form-control1 > label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n/*.form-floating1 > .form-control:focus ~ label,*/\n/*.form-floating1 > .form-control:not(:placeholder-shown) ~ label,*/\n.form-floating1 > label.form-control-mini,\n.form-floating1 > .form-select ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.form-floating1 > .form-control-super::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid !important;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0 !important;\n  border-left: 0.3em solid transparent;\n}\n\n.form-floating1 > .form-control:not(:-moz-placeholder-shown) ~ label::after {\n  position: absolute;\n  inset: 1rem 0.375rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: var(--bs-body-bg);\n  border-radius: var(--bs-border-radius);\n}\n/*.form-floating1 > .form-control:focus ~ label::after,*/\n/*.form-floating1 > .form-control:not(:placeholder-shown) ~ label::after,*/\n.form-floating1 > .form-control-plaintext ~ label::after,\n.form-floating1 > .form-select ~ label::after {\n  position: absolute;\n  inset: 1rem 0.375rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  /*background-color: var(--bs-body-bg);\n  border-radius: var(--bs-border-radius);*/\n}\n.form-floating1 > .form-control:-webkit-autofill ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating1 > .form-control-plaintext ~ label {\n  border-width: var(--bs-border-width) 0;\n}\n.form-floating1 > :disabled ~ label,\n.form-floating1 > .form-control:disabled ~ label {\n  color: #6c757d;\n}\n.form-floating1 > :disabled ~ label::after,\n.form-floating1 > .form-control:disabled ~ label::after {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-floating1 > .form-control1 > .button-container {\n  border: 1px dashed #000000;\n  border-width: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
